export function configuracaoalarmetanquesInRequest(params = {}) {
  return {
    type: '@configuracaoalarmetanque/CONFIGURACAOALARMETANQUES_IN_REQUEST',
    payload: { params },
  };
}

export function findConfiguracaoAlarmeTanque(id) {
  return {
    type: '@configuracaoalarmetanque/FIND_CONFIGURACAOALARMETANQUE',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@configuracaoalarmetanque/FAILED_REQUEST',
  };
}

export function updateConfiguracaoAlarmeTanque(data, params) {
  return {
    type: '@configuracaoalarmetanque/UPDATE_CONFIGURACAOALARMETANQUE',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@configuracaoalarmetanque/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@configuracaoalarmetanque/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@configuracaoalarmetanque/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@configuracaoalarmetanque/RECORD_FILTERING',
    payload: { params },
  };
}

export function resetFiltering(params = {}) {
  return {
    type: '@configuracaoalarmetanque/RESET_FILTERING',
    payload: { params },
  };
}
